<div id="payment-dialog-container">
  <div class="title margin-top-1">
    <div [outerHTML]="data.title | translate "></div>
  </div>
  <div class="flex-space-between margin-top-2">
    <button
      mat-raised-button
      style="color: black"
      type="button"
      (click)="closeDialog(false)"
    >
      <span>{{ "cancel" | translate }}</span>
    </button>
    <button
      mat-raised-button
      color="warn"
      type="button"
      (click)="closeDialog(true)"
    >
      <span>{{ "accept" | translate }}</span>
    </button>
  </div>
</div>
